import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { usePrefetchProjectDetailData } from '@/console/features/projects/hooks/use-prefetch-project-detail-data/use-prefetch-project-detail-data';
import { useLazyReadProjectQuery } from '@/shared/redux/api/assets/projects/projects-api';

export const useProjectVersionNavigate = (
  projectId: string,
  versionId: string,
) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const prefetchProjectDetail = usePrefetchProjectDetailData();
  // Fetch the project lazily: the full project is already in the list, so only the
  // rare missing-version fallback needs to re-read it.
  const [refetchProject] = useLazyReadProjectQuery();

  const onMouseEnter = () => {
    prefetchProjectDetail(projectId);
  };

  const navigateToItem = () => {
    if (!versionId) {
      refetchProject({ projectId });
      toast.warn(t('projects:project_version_not_available_checking'));
      return;
    }

    navigate(`/projects/${projectId}`);
  };

  return { navigateToItem, onMouseEnter };
};
